/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { ElementType } from "react";
import { Clay } from "../utilities";
import { diagonalCSS, horizontalCSS } from "./Skeleton.styles";
import type { SkeletonProps } from "./Skeleton.types";

export const Skeleton = <Element extends ElementType>({
  sx,
  duration = "1300ms",
  height = "200px",
  width = "200px",
  rounded = "base",
  variation = "horizontal",
  ...props
}: SkeletonProps<Element>) => {
  return (
    <Clay
      css={[
        variation === "diagonal"
          ? diagonalCSS({ width, height, duration })
          : horizontalCSS({ width, height, duration }),
        {
          borderRadius: vars.rounded[rounded],
        },
        sx,
      ]}
      {...props}
    />
  );
};
